// ============================================================
// useIsTeamOwner — vraća true ako je trenutni user vlasnik tima
// koji je trenutno u scope-u (prema URL-u / TeamContext-u).
//
// Pravila:
//   1. user.uid === teamData.ownerUid → owner
//   2. Legacy fallback: tim nema ownerUid (stari Infobip zapisi) +
//      user je globalni super-admin (user.isAdmin === true) → owner
//   3. Inače false
//
// Koristi se umjesto user.isAdmin za odluke koje ovise o konkretnom
// timu (npr. može li user uređivati raspored ovog tima, utakmice,
// dodavati igrače u tim). Za cross-team super-admin provjere
// (npr. /admin-stats) i dalje se koristi user.isAdmin izravno.
// ============================================================

import { useTeam } from '../contexts/TeamContext';

export const useIsTeamOwner = (user) => {
  const { teamData } = useTeam();

  if (!user || !teamData) return false;

  if (user.uid && teamData.ownerUid && user.uid === teamData.ownerUid) {
    return true;
  }

  // Legacy: timovi bez ownera + globalni admin = effectively owner.
  // Ovo će se ukloniti kad svi timovi dobiju ownerUid.
  if (!teamData.ownerUid && user.isAdmin === true) {
    return true;
  }

  return false;
};

// Returns true for owner OR any manager (managerUids array on team doc).
// Use this for edit-gating (matches, players, schedule).
// Use useIsTeamOwner for sensitive ops (settings, delete team).
export const useCanEditTeam = (user) => {
  const { teamData } = useTeam();

  if (!user || !teamData) return false;
  if (user.uid === teamData.ownerUid) return true;
  if (!teamData.ownerUid && user.isAdmin === true) return true;
  return Array.isArray(teamData.managerUids) && teamData.managerUids.includes(user.uid);
};

export default useIsTeamOwner;
